// // ============================================================
// // src/components/admin/RenewSubscription.js
// // ✅ Shown when hospital subscription is expiring or expired
// // ✅ Opens Razorpay payment → on success calls /payment/verify
// // ✅ Auto-hides when status is active with >7 days left
// // ============================================================
// import React, { useState, useEffect } from "react";
// import { useHospital } from "../../context/HospitalContext";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const PLANS = [
//   { id: "starter", label: "Starter", price: "₹999/mo", amount: 99900 },
//   { id: "pro", label: "Pro", price: "₹1,999/mo", amount: 199900 },
//   { id: "enterprise", label: "Enterprise", price: "₹3,499/mo", amount: 349900 },
// ];

// export default function RenewSubscription({ showNotify }) {
//   const { hospital, refreshHospital } = useHospital();
//   const [status, setStatus] = useState(null);
//   const [paying, setPaying] = useState(false);
//   const [selPlan, setSelPlan] = useState("pro");
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     if (!hospital?._id) return;
//     fetchStatus();
//   }, [hospital?._id]);

//   const fetchStatus = async () => {
//     try {
//       const res = await fetch(
//         `${API_URL}/superadmin/payment/status/${hospital._id}`,
//       );
//       const data = await res.json();
//       setStatus(data);
//       // Show banner if expired or expiring within 7 days
//       setVisible(
//         data.needsRenewal ||
//           data.isExpired ||
//           data.subscriptionStatus === "blocked",
//       );
//     } catch (_) {}
//   };

//   const handleRenew = async () => {
//     if (!window.Razorpay) {
//       showNotify?.(
//         "❌ Error",
//         "Razorpay SDK not loaded. Check internet.",
//         true,
//       );
//       return;
//     }
//     setPaying(true);
//     try {
//       // Step 1 — Create order
//       const orderRes = await fetch(
//         `${API_URL}/superadmin/payment/create-order`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ hospitalId: hospital._id, plan: selPlan }),
//         },
//       );
//       const orderData = await orderRes.json();
//       if (!orderRes.ok) throw new Error(orderData.message);

//       // Step 2 — Open Razorpay checkout
//       const options = {
//         key: orderData.keyId,
//         amount: orderData.amount,
//         currency: orderData.currency,
//         name: "VidyaOne",
//         description: `${selPlan.charAt(0).toUpperCase() + selPlan.slice(1)} Plan — 30 days`,
//         order_id: orderData.orderId,
//         prefill: {
//           name: hospital.name,
//           email: hospital.email || "",
//           contact: hospital.phone || "",
//         },
//         theme: { color: "#0d7377" },
//         handler: async (response) => {
//           // Step 3 — Verify payment
//           try {
//             const verifyRes = await fetch(
//               `${API_URL}/superadmin/payment/verify`,
//               {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   razorpay_order_id: response.razorpay_order_id,
//                   razorpay_payment_id: response.razorpay_payment_id,
//                   razorpay_signature: response.razorpay_signature,
//                   hospitalId: hospital._id,
//                   plan: selPlan,
//                 }),
//               },
//             );
//             const verifyData = await verifyRes.json();
//             if (!verifyRes.ok) throw new Error(verifyData.message);

//             showNotify?.(
//               "✅ Payment Successful!",
//               `Subscription active for 30 days. Expiry: ${new Date(verifyData.expiry).toLocaleDateString("en-IN")}`,
//             );
//             await refreshHospital?.();
//             await fetchStatus();
//             setVisible(false);
//           } catch (err) {
//             showNotify?.("❌ Verification Failed", err.message, true);
//           }
//           setPaying(false);
//         },
//         modal: {
//           ondismiss: () => setPaying(false),
//         },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       showNotify?.("❌ Payment Error", err.message, true);
//       setPaying(false);
//     }
//   };

//   if (!visible || !status) return null;

//   const isExpired =
//     status.isExpired ||
//     status.subscriptionStatus === "blocked" ||
//     status.subscriptionStatus === "expired";
//   const daysLeft = status.daysLeft;

//   return (
//     <div
//       style={{
//         background: isExpired
//           ? "linear-gradient(135deg,#7f1d1d,#dc2626)"
//           : "linear-gradient(135deg,#78350f,#d97706)",
//         borderRadius: 12,
//         padding: "16px 20px",
//         marginBottom: 20,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         flexWrap: "wrap",
//         gap: 12,
//       }}
//     >
//       <div>
//         <div
//           style={{
//             color: "#fff",
//             fontWeight: 700,
//             fontSize: 14,
//             marginBottom: 4,
//           }}
//         >
//           {isExpired
//             ? "⚠️ Subscription Expired — Panel Locked"
//             : `⚠️ Subscription Expiring in ${daysLeft} day${daysLeft !== 1 ? "s" : ""}`}
//         </div>
//         <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 12 }}>
//           {isExpired
//             ? "Renew now to restore full access to your admin panel."
//             : "Renew now to avoid interruption to your hospital's services."}
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 10,
//           flexWrap: "wrap",
//         }}
//       >
//         {/* Plan selector */}
//         <select
//           value={selPlan}
//           onChange={(e) => setSelPlan(e.target.value)}
//           style={{
//             padding: "7px 12px",
//             borderRadius: 7,
//             border: "none",
//             fontSize: 12,
//             fontWeight: 600,
//             cursor: "pointer",
//           }}
//         >
//           {PLANS.map((p) => (
//             <option key={p.id} value={p.id}>
//               {p.label} — {p.price}
//             </option>
//           ))}
//         </select>
//         {/* Pay button */}
//         <button
//           onClick={handleRenew}
//           disabled={paying}
//           style={{
//             padding: "8px 18px",
//             borderRadius: 8,
//             border: "none",
//             background: paying ? "rgba(255,255,255,0.4)" : "#fff",
//             color: isExpired ? "#dc2626" : "#d97706",
//             fontWeight: 700,
//             fontSize: 13,
//             cursor: paying ? "not-allowed" : "pointer",
//             fontFamily: "'DM Sans',sans-serif",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {paying ? "Opening payment..." : "💳 Renew Now"}
//         </button>
//       </div>
//     </div>
//   );
// }

////////// pranjeev

// // ============================================================
// // src/components/admin/RenewSubscription.js
// // ✅ Shown when hospital subscription is expiring or expired
// // ✅ Opens Razorpay payment → on success calls /payment/verify
// // ✅ Auto-hides when status is active with >7 days left
// // ============================================================
// import React, { useState, useEffect } from "react";
// import { useHospital } from "../../context/HospitalContext";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const PLANS = [
//   { id: "starter", label: "Starter", price: "₹999/mo", amount: 99900 },
//   { id: "pro", label: "Pro", price: "₹1,999/mo", amount: 199900 },
//   { id: "enterprise", label: "Enterprise", price: "₹3,499/mo", amount: 349900 },
// ];

// export default function RenewSubscription({ showNotify }) {
//   const { hospital, refreshHospital } = useHospital();
//   const [status, setStatus] = useState(null);
//   const [paying, setPaying] = useState(false);
//   const [selPlan, setSelPlan] = useState("pro");
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     if (!hospital?._id) return;
//     fetchStatus();
//   }, [hospital?._id]);

//   const fetchStatus = async () => {
//     try {
//       const res = await fetch(
//         `${API_URL}/superadmin/payment/status/${hospital._id}`,
//       );
//       const data = await res.json();
//       setStatus(data);
//       // Show banner if expired or expiring within 7 days
//       setVisible(
//         data.needsRenewal ||
//           data.isExpired ||
//           data.subscriptionStatus === "blocked",
//       );
//     } catch (_) {}
//   };

//   const handleRenew = async () => {
//     if (!window.Razorpay) {
//       showNotify?.(
//         "❌ Error",
//         "Razorpay SDK not loaded. Check internet.",
//         true,
//       );
//       return;
//     }
//     setPaying(true);
//     try {
//       // Step 1 — Create order
//       const orderRes = await fetch(
//         `${API_URL}/superadmin/payment/create-order`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ hospitalId: hospital._id, plan: selPlan }),
//         },
//       );
//       const orderData = await orderRes.json();
//       if (!orderRes.ok) throw new Error(orderData.message);

//       // Step 2 — Open Razorpay checkout
//       const options = {
//         key: orderData.keyId,
//         amount: orderData.amount,
//         currency: orderData.currency,
//         name: "PranJeev",
//         description: `${selPlan.charAt(0).toUpperCase() + selPlan.slice(1)} Plan — 30 days`,
//         order_id: orderData.orderId,
//         prefill: {
//           name: hospital.name,
//           email: hospital.email || "",
//           contact: hospital.phone || "",
//         },
//         theme: { color: "#0d7377" },
//         handler: async (response) => {
//           // Step 3 — Verify payment
//           try {
//             const verifyRes = await fetch(
//               `${API_URL}/superadmin/payment/verify`,
//               {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({
//                   razorpay_order_id: response.razorpay_order_id,
//                   razorpay_payment_id: response.razorpay_payment_id,
//                   razorpay_signature: response.razorpay_signature,
//                   hospitalId: hospital._id,
//                   plan: selPlan,
//                 }),
//               },
//             );
//             const verifyData = await verifyRes.json();
//             if (!verifyRes.ok) throw new Error(verifyData.message);

//             showNotify?.(
//               "✅ Payment Successful!",
//               `Subscription active for 30 days. Expiry: ${new Date(verifyData.expiry).toLocaleDateString("en-IN")}`,
//             );
//             await refreshHospital?.();
//             await fetchStatus();
//             setVisible(false);
//           } catch (err) {
//             showNotify?.("❌ Verification Failed", err.message, true);
//           }
//           setPaying(false);
//         },
//         modal: {
//           ondismiss: () => setPaying(false),
//         },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       showNotify?.("❌ Payment Error", err.message, true);
//       setPaying(false);
//     }
//   };

//   if (!visible || !status) return null;

//   const isExpired =
//     status.isExpired ||
//     status.subscriptionStatus === "blocked" ||
//     status.subscriptionStatus === "expired";
//   const daysLeft = status.daysLeft;

//   return (
//     <div
//       style={{
//         background: isExpired
//           ? "linear-gradient(135deg,#7f1d1d,#dc2626)"
//           : "linear-gradient(135deg,#78350f,#d97706)",
//         borderRadius: 12,
//         padding: "16px 20px",
//         marginBottom: 20,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         flexWrap: "wrap",
//         gap: 12,
//       }}
//     >
//       <div>
//         <div
//           style={{
//             color: "#fff",
//             fontWeight: 700,
//             fontSize: 14,
//             marginBottom: 4,
//           }}
//         >
//           {isExpired
//             ? "⚠️ Subscription Expired — Panel Locked"
//             : `⚠️ Subscription Expiring in ${daysLeft} day${daysLeft !== 1 ? "s" : ""}`}
//         </div>
//         <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 12 }}>
//           {isExpired
//             ? "Renew now to restore full access to your admin panel."
//             : "Renew now to avoid interruption to your hospital's services."}
//         </div>
//       </div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 10,
//           flexWrap: "wrap",
//         }}
//       >
//         {/* Plan selector */}
//         <select
//           value={selPlan}
//           onChange={(e) => setSelPlan(e.target.value)}
//           style={{
//             padding: "7px 12px",
//             borderRadius: 7,
//             border: "none",
//             fontSize: 12,
//             fontWeight: 600,
//             cursor: "pointer",
//           }}
//         >
//           {PLANS.map((p) => (
//             <option key={p.id} value={p.id}>
//               {p.label} — {p.price}
//             </option>
//           ))}
//         </select>
//         {/* Pay button */}
//         <button
//           onClick={handleRenew}
//           disabled={paying}
//           style={{
//             padding: "8px 18px",
//             borderRadius: 8,
//             border: "none",
//             background: paying ? "rgba(255,255,255,0.4)" : "#fff",
//             color: isExpired ? "#dc2626" : "#d97706",
//             fontWeight: 700,
//             fontSize: 13,
//             cursor: paying ? "not-allowed" : "pointer",
//             fontFamily: "'DM Sans',sans-serif",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {paying ? "Opening payment..." : "💳 Renew Now"}
//         </button>
//       </div>
//     </div>
//   );
// }

////////// real razorpay

// ============================================================
// src/components/admin/RenewSubscription.js
// ✅ Shown when hospital subscription is expiring or expired
// ✅ UPDATED: Real Razorpay Subscription API (auto-renewal)
// ✅ Auto-hides when status is active with >7 days left
// ============================================================
import React, { useState, useEffect } from "react";
import { useHospital } from "../../context/HospitalContext";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const PLANS = [
  { id: "starter", label: "Starter", price: "₹999/mo", amount: 99900 },
  { id: "pro", label: "Pro", price: "₹1,999/mo", amount: 199900 },
  { id: "enterprise", label: "Enterprise", price: "₹3,499/mo", amount: 349900 },
];

export default function RenewSubscription({ showNotify }) {
  const { hospital, refreshHospital } = useHospital();
  const [status, setStatus] = useState(null);
  const [paying, setPaying] = useState(false);
  const [selPlan, setSelPlan] = useState("pro");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!hospital?._id) return;
    fetchStatus();
  }, [hospital?._id]);

  const fetchStatus = async () => {
    try {
      const res = await fetch(
        `${API_URL}/superadmin/payment/status/${hospital._id}`,
      );
      const data = await res.json();
      setStatus(data);
      // Show banner if expired or expiring within 7 days
      setVisible(
        data.needsRenewal ||
          data.isExpired ||
          data.subscriptionStatus === "blocked",
      );
    } catch (_) {}
  };

  const handleRenew = async () => {
    if (!window.Razorpay) {
      showNotify?.(
        "❌ Error",
        "Razorpay SDK not loaded. Check internet.",
        true,
      );
      return;
    }
    setPaying(true);
    try {
      // ✅ Step 1 — Create real Razorpay Subscription
      const orderRes = await fetch(`${API_URL}/razorpay/create-subscription`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ hospitalId: hospital._id, plan: selPlan }),
      });
      const orderData = await orderRes.json();
      if (!orderRes.ok) throw new Error(orderData.message);

      // ✅ Step 2 — Open Razorpay Subscription Checkout
      const options = {
        key: orderData.keyId,
        subscription_id: orderData.subscriptionId, // ✅ subscription_id not order_id
        name: "PranJeev",
        description: `${selPlan.charAt(0).toUpperCase() + selPlan.slice(1)} Plan — Auto-renews monthly`,
        prefill: {
          name: hospital.name,
          email: hospital.email || "",
          contact: hospital.phone || "",
        },
        theme: { color: "#0d7377" },
        handler: async (response) => {
          // ✅ Step 3 — Verify subscription payment
          try {
            const verifyRes = await fetch(
              `${API_URL}/razorpay/verify-subscription`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_subscription_id: response.razorpay_subscription_id,
                  razorpay_signature: response.razorpay_signature,
                  hospitalId: hospital._id,
                  plan: selPlan,
                }),
              },
            );
            const verifyData = await verifyRes.json();
            if (!verifyRes.ok) throw new Error(verifyData.message);

            showNotify?.(
              "✅ Subscription Active!",
              `Subscription active and auto-renews monthly. Expiry: ${new Date(verifyData.hospital?.subscriptionExpiry).toLocaleDateString("en-IN")}`,
            );
            await refreshHospital?.();
            await fetchStatus();
            setVisible(false);
          } catch (err) {
            showNotify?.("❌ Verification Failed", err.message, true);
          }
          setPaying(false);
        },
        modal: {
          ondismiss: () => setPaying(false),
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      showNotify?.("❌ Payment Error", err.message, true);
      setPaying(false);
    }
  };

  if (!visible || !status) return null;

  const isExpired =
    status.isExpired ||
    status.subscriptionStatus === "blocked" ||
    status.subscriptionStatus === "expired";
  const daysLeft = status.daysLeft;

  return (
    <div
      style={{
        background: isExpired
          ? "linear-gradient(135deg,#7f1d1d,#dc2626)"
          : "linear-gradient(135deg,#78350f,#d97706)",
        borderRadius: 12,
        padding: "16px 20px",
        marginBottom: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      <div>
        <div
          style={{
            color: "#fff",
            fontWeight: 700,
            fontSize: 14,
            marginBottom: 4,
          }}
        >
          {isExpired
            ? "⚠️ Subscription Expired — Panel Locked"
            : `⚠️ Subscription Expiring in ${daysLeft} day${daysLeft !== 1 ? "s" : ""}`}
        </div>
        <div style={{ color: "rgba(255,255,255,0.8)", fontSize: 12 }}>
          {isExpired
            ? "Renew now to restore full access to your admin panel."
            : "Renew now to avoid interruption to your hospital's services."}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          flexWrap: "wrap",
        }}
      >
        {/* Plan selector */}
        <select
          value={selPlan}
          onChange={(e) => setSelPlan(e.target.value)}
          style={{
            padding: "7px 12px",
            borderRadius: 7,
            border: "none",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          {PLANS.map((p) => (
            <option key={p.id} value={p.id}>
              {p.label} — {p.price}
            </option>
          ))}
        </select>
        {/* Pay button */}
        <button
          onClick={handleRenew}
          disabled={paying}
          style={{
            padding: "8px 18px",
            borderRadius: 8,
            border: "none",
            background: paying ? "rgba(255,255,255,0.4)" : "#fff",
            color: isExpired ? "#dc2626" : "#d97706",
            fontWeight: 700,
            fontSize: 13,
            cursor: paying ? "not-allowed" : "pointer",
            fontFamily: "'DM Sans',sans-serif",
            whiteSpace: "nowrap",
          }}
        >
          {paying ? "Opening payment..." : "💳 Renew Now"}
        </button>
      </div>
    </div>
  );
}
